import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

import root from './utils'

export interface CommonConfQQBannerInfo {
  url: string
  qqCode: string
}
export interface CommonConfInvitationShowInfo {
  iosStatus: number // 1 展示 0 不展示
  androidStatus: number // 1 展示 0 不展示
}

export interface CommonConf {
  qqBannerInfo: CommonConfQQBannerInfo
  invitationShowInfo: CommonConfInvitationShowInfo
  qqCodeInfo: {
    qqCode: string
  }
  complianceOfficialAccountInfo: {
    compliantDouyinId: string
    compliantXiaohongshuId: string
  }
}

type HomeProps = {
  roleInfo: any
  goodReviewCnt: number
  chatList: any
  findList: any
  storyList: any
  userInfo: any
  commonConf: CommonConf
}

const initialState = {
  roleInfo: null,
  goodReviewCnt: 0,
  user: null,
  findList: [],
  findListMore: false,
  chatList: [],
  storyList: [],
  userInfo: {},
  commonConf: {
    qqBannerInfo: {
      url: '',
      qqCode: '',
    },
    qqCodeInfo: {
      qqCode: '',
    },
    invitationShowInfo: {
      iosStatus: 0,
      androidStatus: 0,
    },
    complianceOfficialAccountInfo: {
      compliantDouyinId: '',
      compliantXiaohongshuId: '',
    },
  },
} as HomeProps

export const getFindList = createAsyncThunk<any, any>(
  'getFindList',
  async (arg, store) => {
    return req(
      '/xai_discover',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getChatList = createAsyncThunk<any, any>(
  'getChatList',
  async (arg, store) => {
    return req(
      '/xai_conversations',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getRoleInfo = createAsyncThunk<any, any>(
  'getRoleInfo',
  async (arg, store) => {
    return req(
      '/xai_get_role_display_info',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getUserInfo = createAsyncThunk<any, any>(
  'getUserInfo',
  async (arg, store) => {
    return req(
      '/xai_get_user_info',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const updateUserInfo = createAsyncThunk<any, any>(
  'updateUserInfo',
  async (arg, store) => {
    return req(
      '/xai_update_user_info',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getCommonConf = createAsyncThunk<CommonConf, any>(
  'getCommonConf',
  async (arg, store) => {
    return req('/config/get_h5_common_conf', {}, store, false, null)
  }
)

export const reportSlice = createSlice({
  name: 'share',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFindList.fulfilled, (state, action) => {
      return {
        ...state,
        findList: action.payload.simpleRoles,
        findListMore: action.payload.more,
      }
    })
    builder.addCase(getChatList.fulfilled, (state, action) => {
      return {
        ...state,
        chatList: action.payload?.conversations,
        storyList: action.payload?.eventsConversations,
      }
    })
    builder.addCase(getRoleInfo.fulfilled, (state, action) => {
      return {
        ...state,
        roleInfo: action.payload?.data,
      }
    })
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      return {
        ...state,
        userInfo: action.payload,
      }
    })
    builder.addCase(getCommonConf.fulfilled, (state, action) => {
      return {
        ...state,
        commonConf: action.payload,
      }
    })
  },
})

export default reportSlice.reducer
